import React from "react";
import "../styles/Summary.css";

const Summary = ({ summary, section = {}, derived = {} }) => {
  return (
    <section
      className="summary section wow animate__animated animate__fadeInUp"
      id="summary"
    >
      <span className="section__subtitle">{section.subtitle}</span>
      <h2 className="section__title">{section.title}</h2>
      <div className="summary__container">
        <div className="summary__data">
          <p className="summary__description">{summary.description}</p>
          <div className="summary__info">
            {summary.info.map((item, index) => (
              <div key={index} className="summary__info-item">
                <span className="summary__info-title">
                  {item.derive && derived[item.derive] != null
                    ? derived[item.derive]
                    : item.value}
                </span>
                <span className="summary__info-name">
                  {item.label} <br /> {item.subLabel}
                </span>
              </div>
            ))}
          </div>
          <div className="summary__buttons">
            <a
              download="resume.pdf"
              href="/assets/pdf/resume.pdf"
              className="button button--flex"
            >
              Download CV <i className="fas fa-download button__icon"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Summary;
